import { useCallback, useRef, useState } from 'react';
import {
  fetchEnderecoPorCep,
  formatCepDisplay,
  normalizeCep,
  CEP_FIELD_NAMES,
} from '../utils/cepLookup';

export function useCepAutofill(form, messageApi, fieldNames = {}) {
  const fields = { ...CEP_FIELD_NAMES, ...fieldNames };
  const [cepLoading, setCepLoading] = useState(false);
  const lastFetched = useRef('');

  const lookupCep = useCallback(async (rawCep) => {
    const digits = normalizeCep(rawCep);
    if (digits.length !== 8 || digits === lastFetched.current) return;

    setCepLoading(true);
    try {
      const endereco = await fetchEnderecoPorCep(digits);
      if (!endereco) {
        messageApi.warning('CEP não encontrado. Preencha o endereço manualmente.');
        return;
      }

      lastFetched.current = digits;
      form.setFieldsValue({
        [fields.endereco]: endereco.endereco,
        [fields.bairro]: endereco.bairro,
        [fields.cidade]: endereco.cidade,
        [fields.estado]: endereco.estado,
      });

      if (!endereco.endereco) {
        messageApi.info('CEP localizado. Informe rua e número se necessário.');
      }
    } catch {
      messageApi.error('Não foi possível consultar o CEP. Tente novamente.');
    } finally {
      setCepLoading(false);
    }
  }, [form, messageApi, fields.bairro, fields.cidade, fields.endereco, fields.estado]);

  const handleCepChange = useCallback((e) => {
    const formatted = formatCepDisplay(e.target.value);
    form.setFieldValue(fields.cep, formatted);
    const digits = normalizeCep(formatted);
    if (digits.length < 8) {
      lastFetched.current = '';
    }
    if (digits.length === 8) {
      lookupCep(formatted);
    }
  }, [form, fields.cep, lookupCep]);

  const handleCepBlur = useCallback((e) => {
    lookupCep(e.target.value);
  }, [lookupCep]);

  return {
    cepLoading,
    cepInputProps: {
      placeholder: '00000-000',
      maxLength: 9,
      onChange: handleCepChange,
      onBlur: handleCepBlur,
    },
  };
}
